import BaseService from "./baseService";
import { reloadCompanies } from "../redux/actions/index";

export class CompanyService extends BaseService {
  constructor(base) {
    super(base);
    this.url = "/companies";
    this.name = "Companies";
    //this.BASE_URL = "http://localhost:3000";
    //this.BASE_URL = "http://34.123.161.156:4702";
  }
  picture(company) {
    return this.get('/company/picture/' + company).then(function (data) {
      return data;
    });
    //return 'https://rinocerontemedia-images.s3.amazonaws.com/comp-5b48ea838730c62890cf8db6?AWSAccessKeyId=AKIAJDWZKWM4O3YRZL6Q&Expires=1652215287&Signature=5qu7ye8duZ0XEuoqmfu4T1yq8Nc%3D';
    //return `https://www.facebook.com/RinoceronteMedia/photos/a.3741943842594987/3742066212582750/`;
  }

  getCompany(company){

    return this.get("/companies/" + company).then(function (data) {
      return data;
    });
  }
  MatchName(id) {
    let answer = this.searchId(this.store.getState().companies, id);
    return answer ? answer.name : "No asignado";
  }
  changeConfig(data) {
    const url = "/companies/change-config";
    return this.post(url, JSON.stringify(data));
  }
  reload() {
    let self = this;
    let filter = {
      include: [{relation: 'brands'}]
    };
    return this.get(this.getUrl(filter)).then(function (data) {
      if (!data.hasOwnProperty("error")) {
        self.store.dispatch(reloadCompanies(data));
      }
    });
  }
}

export default CompanyService;
